<template>
  <div>
    <list-table
      url="accounters-report/internal-transfers"
      title="انتقال وجه داخلی"
      :fields="fields"
      :params="params"
      :excelroute="'asdasd'"></list-table>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import TableShowData from "../../components/table";
import UserList from "../../components/UserList";
import persianDate from "../../helpers/persianDate";

export default {
  name: "Clients",
  data() {
    return {
      params: [
        {
          label: "از تاریخ",
          field: "datefrom",
          type: "date-picker",
        },
        {
          label: "تا تاریخ",
          field: "dateto",
          type: "date-picker",
        },
      ],
      fields: [
        {
          key: "id",
          label: "کد",
        },
        {
          key: "from_bank",
          label: "بانک مبدا",
        },
        {
          key: "to_bank",
          label: "بانک مقصد",
        },
        {
          key: "amount",
          label: "مبلغ",
        },
        {
          key: "karmozd",
          label: "کارمزد",
        },
        {
          key: "tracking_number",
          label: "کد رهگیری",
        },
        {
          key: "created_at",
          label: "تاریخ تراکنش",
          formatter(value, key, item) {
            return persianDate.getDate(value);
          },
        },
      ],
    };
  },
  components: {
    "list-table": TableShowData,
    "user-list": UserList,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "صفحه اصلی",
        route: "/dashboard",
      },
      {
        title: "انتقال وجه داخلی",
      },
    ]);
  },
};
</script>
